
import AboutMe from '~/components/AboutMe/index.vue'
export default {
  components: { AboutMe },
  middleware: ['returnUrl'],
  head() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      title:
        `${this.$custom$t('nav.about')}` +
        ' | ' +
        this.$store.state.settings.title,
      link: [
        {
          hid: 'icon',
          rel: 'icon',
          type: 'image/x-icon',
          href: this.$store.state.settings.noImage,
        },
      ],
      meta: [
        { hid: 'og-type', property: 'og:type', content: 'website' },
        {
          hid: 'title',
          property: 'title',
          content:
            `${this.$custom$t('nav.about')}` +
            ' | ' +
            this.$store.state.settings.title,
        },
        {
          hid: 'description',
          name: 'description',
          content: this.$store.state.settings.contents[
            this.$i18n.locale
          ].home.banner.overview.substring(0, 152),
        },
        {
          hid: 'og-title',
          property: 'og:title',
          content:
            `${this.$custom$t('nav.about')}` +
            ' | ' +
            this.$store.state.settings.title,
        },
        {
          hid: 'og-desc',
          property: 'og:description',
          content: this.$store.state.settings.contents[
            this.$i18n.locale
          ].home.banner.overview.substring(0, 152),
        },
        {
          hid: 'og-image',
          property: 'og:image',
          content:
            this.$store.state.settings.contents[this.$i18n.locale].seo.home
              .image,
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: this.$store.state.settings.title,
        },
        {
          hid: 'og-url',
          property: 'og:url',
          content:
            this.$store.state.settings.contents[this.$i18n.locale].seo.home.url,
        },
        { hid: 't-type', name: 'twitter:card', content: 'summary_large_image' },
      ],
      script: [
        ...this.$store.state.settings.analyticSettings
          .filter((as) => as.key === 'script' && as.source === null)
          .map((asettings) => ({
            type: 'text/javascript',
            innerHTML: asettings.value,
          })),
        ...this.$store.state.settings.analyticSettings
          .filter((as) => as.key === 'script' && as.source !== null)
          .map((asettings) => ({
            type: 'text/javascript',
            src: asettings.source,
            innerHTML: asettings.value,
          })),
               ...this.$store.state.settings.contents.customScripts
          .filter((s) => s?.overview !== '-' && s?.overview !== '')
          .map((script) => ({
            type: 'text/javascript',
            innerHTML: script?.overview,
          })),
        ...this.$store.state.settings.contents.customScripts
          .filter((s) => s?.description !== '-' && s?.description !== '')
          .map((script) => ({
            type: 'text/javascript',
            src: script?.description,
            async: true,
            defer: true,
          })),
        ...this.$store.state.settings.contents.googleAnalytics
          .filter((ga) => ga?.title.startsWith('G-'))
          .map((ga) => ({
            type: 'text/javascript',
            src: `https://www.googletagmanager.com/gtag/js?id=${ga?.title}`,
            async: true,
            defer: true,
          })),
        ...this.$store.state.settings.contents.googleAnalytics
          .filter((ga) => ga?.title.startsWith('G-') && ga?.title !== '')
          .map((ga) => ({
            type: 'text/javascript',
            innerHTML: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${ga?.title}');`,
          })),


        ...(this.$store.state.settings.customScripts || [])
          .filter((s) => s?.overview !== '-' && s?.overview !== '')
          .map((script) => ({
            type: 'text/javascript',
            innerHTML: script?.overview,
          })),
        ...(this.$store.state.settings.customScripts || [])
          .filter((ga) => ga?.description !== '-' && ga?.description !== '')
          .map((ga) => ({
            type: 'text/javascript',
            src: ga?.description,
            async: true,
            defer: true,
          })),
      ],
      __dangerouslyDisableSanitizers: ['script'],
    }
  },
}
